import { atom } from 'recoil'

export const modalThirdPartyState = atom({
  key: 'templateEditModalThirdPartyState',
  default: {
    show: false
  }
})

export const modalSaveState = atom({
  key: 'templateEditModalSaveState',
  default: {
    show: false,
    id: undefined,
    title: '',
    dirty: false,
    valid: false,
    lists: [],
    saveToLists: [],
    selectAll: false
  }
})

export const modalErrorState = atom({
  key: 'templateEditModalErrorState',
  default: {
    show: false
  }
})

export const modalOfferLightUpsellState = atom({
  key: 'templateEdit__modalOfferLightUpsell',
  default: {
    show: false
  }
})
